export const SET_SHARED_DATA = '@APP/SET_SHARED_DATA';
export const RESET_SHARED_DATA = '@APP/RESET_SHARED_DATA';
